import React from 'react';
import { useFormContext } from 'react-hook-form';
import { FACT_NAMES_NUMERIC } from '@trnsact/business-criteria';
import { CurrencyInputField, InputField } from 'components/form';
import { FinanceProgramForm } from '../../../../schema';

interface Props {
  index: number;
  type: FACT_NAMES_NUMERIC;
}

export const NumberFieldsByRule = ({ index, type }: Props) => {
  const { control } = useFormContext<FinanceProgramForm>();

  const currencyInputs = [
    FACT_NAMES_NUMERIC.DOWN_PAYMENT,
    FACT_NAMES_NUMERIC.DEAL_SIZE,
    FACT_NAMES_NUMERIC.NET_FINANCE_AMOUNT,
  ];

  return (
    <>
      {currencyInputs.includes(type) ? (
        <>
          <CurrencyInputField
            label="Min value"
            control={control}
            textFieldProps={{ size: 'small', fullWidth: true }}
            name={`program.first.criteria.conditions.${index}.number.min`}
          />

          <CurrencyInputField
            label="Max value"
            control={control}
            textFieldProps={{ size: 'small', fullWidth: true }}
            name={`program.first.criteria.conditions.${index}.number.max`}
          />
        </>
      ) : (
        <>
          <InputField
            label="Min value"
            control={control}
            name={`program.first.criteria.conditions.${index}.number.min`}
            inputProps={{
              type: 'number',
            }}
          />

          <InputField
            label="Max value"
            control={control}
            name={`program.first.criteria.conditions.${index}.number.max`}
            inputProps={{
              type: 'number',
            }}
          />
        </>
      )}
    </>
  );
};
